module.exports = __webpack_public_path__ + "static/img/38-1.2e78c0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/38-1.jpg
// module id = 7439
// module chunks = 0